var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100", class: { "sm-down": _vm.$wf.isSmDown } },
    [
      _c(
        "w-card-content",
        { style: { paddingBottom: 0 } },
        [
          _vm.isGenerated
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-info", [
                        _vm._v(_vm._s(_vm.$ct("generated-warning"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { md: "1" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      value: _vm.groupId,
                      decimals: 0,
                      fancy: "",
                      disabled: "",
                      label: _vm.$ct("groupID"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "2" } },
                [
                  _c("app-select-journal", {
                    attrs: {
                      label: _vm.$ct("journal"),
                      fancy: "",
                      "filter-to-journals-with-purchase-number": "",
                    },
                    model: {
                      value: _vm.journalId,
                      callback: function ($$v) {
                        _vm.journalId = $$v
                      },
                      expression: "journalId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "3" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      value: _vm.date,
                      label: _vm.$ct("date"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onDate($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "1" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("vat-period"),
                      decimals: 0,
                    },
                    model: {
                      value: _vm.vatPeriod,
                      callback: function ($$v) {
                        _vm.vatPeriod = $$v
                      },
                      expression: "vatPeriod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: _vm.contact ? 2 : 5 } },
                [
                  _c("app-contact-search", {
                    attrs: {
                      "group-id": [1, 2],
                      "disable-create": "",
                      fancy: "",
                      label: _vm.$ct("search-client"),
                    },
                    model: {
                      value: _vm.contact,
                      callback: function ($$v) {
                        _vm.contact = $$v
                      },
                      expression: "contact",
                    },
                  }),
                ],
                1
              ),
              _vm.contact
                ? _c(
                    "w-col",
                    { attrs: { md: "3" } },
                    [
                      _vm.contact.GroupID == 1
                        ? _c("app-sale-search", {
                            attrs: {
                              label: _vm.$ct("labels.invoice"),
                              fancy: "",
                              value: _vm.invoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onSaleSelect($event)
                              },
                            },
                          })
                        : _vm.contact.GroupID == 2
                        ? _c("app-purchase-search", {
                            attrs: {
                              label: _vm.$ct("labels.purchase"),
                              fancy: "",
                              value: _vm.purchase,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onPurchaseSelect($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c("app-diverse-edit-ledger", {
            attrs: { value: _vm.toEditLedger, ledgers: _vm.ledgers },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
              remove: function ($event) {
                return _vm.removeLedger()
              },
            },
          }),
        ],
        1
      ),
      _c("app-diverse-edit-ledgers", {
        attrs: { "selected-item": _vm.toEditLedger, ledgers: _vm.ledgers },
        on: {
          select: function ($event) {
            return _vm.onItemSelected($event)
          },
        },
      }),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12", md: "2" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$ct("total-debet", { value: _vm.totalDebet })) +
                    " "
                ),
              ]),
              _c(
                "w-col",
                {
                  class: { difference: _vm.difference },
                  attrs: { xs: "12", md: "2" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("total-credit", { value: _vm.totalCredit })
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: !_vm.isValid || _vm.isSaving },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }